import { Toasts } from "components";
import { WarningIcon } from "../icons";
import { IPaymentStatusResponse } from "../interfaces/payment-status-interfaces";

const el = {
  root: document.querySelector<HTMLDivElement>('.payment-status'),
  guid: document.querySelector<HTMLDivElement>('.payment-status')?.dataset.query || '',
  counter: document.querySelector<HTMLDivElement>('.payment-status__counter'),
}

export const PaymentStatus = {
  init: () => {
    if (!el.root || !el.guid || !el.counter) return
    PaymentStatus.checkStatus({ startTimer: true });
  },

  checkStatus: async ({ startTimer = false }) => {
    if (startTimer) el.counter.classList.add('payment-status__counter--loading')
    try {
      const response = await fetch(`/umbraco/NetPayment/SiminnPay/status?siminnPayOrderKey=${el.guid}`, {
        method: 'get',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      const data: IPaymentStatusResponse = await response.json()

      if (startTimer) {
        const expires = parseInt(data.Expires.replace("/Date(", "").replace(")/", ""))
        PaymentStatus.startTimer(expires)
      }

      PaymentStatus.redirect({
        status: data.PayStatus,
        orderId: data.NetPaymentOrderId,
      })

    } catch (_) {
      Toasts.addToast({
        title: 'Villa kom upp!',
        text: 'Ekki tókst að sækja stöðu.',
        icon: WarningIcon(),
      })
    }
    if (startTimer) el.counter.classList.remove('payment-status__counter--loading')
  },

  startTimer: (duration = 0) => {

    let x = setInterval(() => {

      const today = new Date().getTime()

      const distance = duration - today
      const minutes = Math.floor((distance / 1000) / 60)
      const seconds = Math.floor((distance / 1000) % 60)

      el.counter.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

      if (distance <= 0) {
        clearInterval(x);
        window.location.href = "/greida/greidslumoguleikar/?error=StatusTimeout";
      }

      PaymentStatus.checkStatus({ startTimer: false });

    }, 1000)
  },

  redirect: ({ status = 0, orderId = '' }) => {
    if (status === 0) {
      window.location.href = "/kvittun/?orderId=" + orderId;
    }
    else if (status === 102 || status === 202) {
      // Cancelled by us or by customer
      window.location.href = "/greida/greidslumoguleikar/?error=StatusCancelled";
    }
    else if (status === 402) {
      window.location.href = "/greida/greidslumoguleikar/?error=StatusTimeout";
    }
    else if (status === 303) {
      window.location.href = "/greida/greidslumoguleikar/?error=StatusPaymentRejected";
    }
  }
}

